import { attributeGetter } from "@bodil/dom/component";
import { applyUniqueID } from "@bodil/dom/dom";
import type { Role } from "aria-attribute-types";
import { customElement } from "lit/decorators.js";

import { BtkStackPage } from "./stack-page";

import styles from "./tab-panel.css?inline";

declare global {
    interface HTMLElementTagNameMap {
        "btk-tab-panel": BtkTabPanel;
    }
}

@customElement("btk-tab-panel")
export class BtkTabPanel extends BtkStackPage {
    @attributeGetter get role(): Role {
        return "tabpanel";
    }

    constructor() {
        super();
        applyUniqueID(this);
    }

    static styles = styles;
}
